<template>
  <div v-if="viewTypeTab === 'desktopViewTab'">
    <v-expansion-panels v-model="getPromoPanel" class="shadow-transparent!" multiple focusable>
      <v-expansion-panel>
        <v-expansion-panel-title>Message</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsTitleMessage :model="model" :actions="actions" :app="app" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>Content Size</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionWindowSize :model="model" :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>User Interaction</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionButtons :actions="actions" :model="model" showCloseOptions />
          <RfRetentionBehavior :model="model" :actions="actions" :clickOutsideSupported="true" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="model.device_type === 'web'">
        <v-expansion-panel-title>Form</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionFieldSet :model="model" :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="model.device_type === 'web'">
        <v-expansion-panel-title>Consent Checkbox</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionConsent :model="model" :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>Close Timer</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsBehavior
            :model="model"
            :actions="actions"
            :hideAutoCloseText="
              model.path_type === 'interstitial' &&
              [
                DefaultDeviceOptions.roku_os.value,
                DefaultDeviceOptions.android_tv.value,
                DefaultDeviceOptions.tv_os.value,
              ].includes(model.device_type)
            "
          />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>Background</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionImageUpload :actions="actions" :model="model" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="inApp">
        <v-expansion-panel-title>In-App Purchase</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsInapp :actions="actions" :app="app" :deviceType="model.device_type" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="model.device_type !== 'web'">
        <v-expansion-panel-title>Deep Link</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsDeeplink :deviceType="model.device_type" :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>Device Metadata</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsMetadata :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="!isMobileAndTvApp && model.path_type !== 'video'">
        <v-expansion-panel-title>Legal</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsLinks :model="model" :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel
        v-if="['android_os', 'android_tv'].includes(model.device_type) || isInterstitialOrPopUp"
      >
        <v-expansion-panel-title>Font Family</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <div class="promo-design-group">
            <v-text-field
              v-if="
                ['android_os', 'android_tv'].includes(model.device_type) ||
                (model.device_type === 'ios' && model.path_type === 'interstitial')
              "
              v-model="actions.rf_retention_button_font_family"
              variant="outlined"
              density="compact"
              label="Font Family"
              persistentPlaceholder
              hideDetails
              placeholder="Enter font family"
            />
            <v-text-field
              v-if="isInterstitialOrPopUp"
              v-model="actions.rf_retention_button_font_size"
              variant="outlined"
              density="compact"
              label="Font Size"
              class="mt-4"
              min="0"
              persistentPlaceholder
              hideDetails
              placeholder="Enter font size"
            />
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="isNotDeviceInterstitial">
        <v-expansion-panel-title>Effect</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfBorderEffects :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>CSS</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <div class="promo-design-group">
            <RfPromoCustomCSS :actions="actions" />
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="model.device_type === 'web' && app.flags.paywalls">
        <v-expansion-panel-title>Paywall</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfPaywallConfig :actions="actions" :model="model" />
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
  <div v-else>
    <v-expansion-panels v-model="getPromoPanel" multiple focusable>
      <v-expansion-panel>
        <v-expansion-panel-title>CONFIGURATION</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsMobileWeb :app="app" :model="model" :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="isNotDeviceInterstitial">
        <v-expansion-panel-title>Effect</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfBorderEffects :actions="actions" mobile />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>CSS</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfPromoCustomCSS :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script setup>
import RfRetentionActionsTitleMessage from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsTitleMessage.vue";
import RfRetentionActionsDeeplink from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsDeeplink.vue";
import RfRetentionActionsMetadata from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsMetadata.vue";
import RfRetentionActionsBehavior from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsBehavior.vue";
import RfRetentionBehavior from "@/components/RfPathCreate/RfRetentionActions/RfRetentionBehavior.vue";
import RfRetentionButtons from "@/components/RfPathCreate/RfRetentionActions/RfRetentionButtons.vue";
import RfRetentionActionsInapp from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsInapp.vue";
import RfRetentionActionsMobileWeb from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsMobileWeb.vue";
import RfRetentionWindowSize from "@/components/RfPathCreate/RfRetentionActions/RfRetentionWindowSize.vue";
import RfPromoCustomCSS from "@/components/RfPromotions/RfPromoCustomCSS.vue";
import RfRetentionFieldSet from "@/components/RfPathCreate/RfRetentionActions/RfRetentionFieldSet.vue";
import RfRetentionConsent from "@/components/RfPathCreate/RfRetentionActions/RfRetentionConsent.vue";
import RfRetentionActionsLinks from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsLinks.vue";
import RfRetentionImageUpload from "@/components/RfPathCreate/RfRetentionActions/components/RfRetentionImageUpload.vue";
import { DefaultDeviceOptions } from "@/utils/constants/DevicesConstants";
import RfBorderEffects from "./RfBorderEffects.vue";
import RfPaywallConfig from "./RfPaywallConfig.vue";
import { hasInapp } from "@/utils/prompts/promptHelpers";
import { computed, ref } from "vue";
import { PromptTypes } from "@/utils/constants/PromoTypesConstants";

const props = defineProps({
  actions: { type: Object, required: true },
  model: { type: Object, required: true },
  app: { type: Object, required: true },
  viewTypeTab: { type: String, default: "desktopViewTab" },
});

const getPromoPanel = ref([0]);

const deviceType = computed(() => props.model.device_type);
const inApp = computed(() => hasInapp(props.model));
const isMobileAndTvApp = computed(
  () =>
    [
      DefaultDeviceOptions.roku_os.value,
      DefaultDeviceOptions.tv_os.value,
      DefaultDeviceOptions.android_tv.value,
    ].includes(deviceType.value) ||
    (DefaultDeviceOptions.ios.value === deviceType.value &&
      props.model.path_type !== PromptTypes.interstitial.value),
);

const isInterstitialOrPopUp = computed(() =>
  [PromptTypes.interstitial.value, PromptTypes.retention_modal.value].includes(
    props.model.path_type,
  ),
);

const isNotDeviceInterstitial = computed(
  () =>
    props.model.path_type !== PromptTypes.interstitial.value ||
    deviceType.value === DefaultDeviceOptions.web.value,
);
</script>
